import Vue from 'vue'
import VueRouter from 'vue-router'
import mineRouter from './modules/mine'
import lessonRouter from './modules/lesson'
import searchRouter from './modules/search'
import documents from './modules/documents'
import activityRouter from './modules/activity'
import giftRouter from './modules/gift'
import rankingRouter from './modules/ranking'
import evaluationRouter from './modules/evaluation'
import loginRouter from './modules/login'
import teachingTeamRouter from './modules/teachingTeam'
import bbsRouter from './modules/bbs'
import payRouter from './modules/pay'
import applyRouter from './modules/apply'
import archiveRouter from './modules/archive'
import yhjRouter from './modules/yhj'
import assessmentRouter from './modules/assessment'
import certificateRouter from './modules/certificate'
import vipRouter from './modules/vip'
import newFooter from '@/router/modules/footerNew.js'
import newArchiveRouter from './newArchive'
import bookRouter from './modules/book'
import curseAdminRouter from './modules/curseAdmin'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  ...bookRouter,
  newArchiveRouter,
  archiveRouter,
  mineRouter,
  ...lessonRouter,
  ...evaluationRouter,
  applyRouter,
  ...searchRouter,
  documents,
  rankingRouter,
  ...yhjRouter,
  ...teachingTeamRouter,
  activityRouter,
  ...payRouter,
  giftRouter,
  ...loginRouter,
  bbsRouter,
  assessmentRouter,
  curseAdminRouter,
  ...certificateRouter,
  vipRouter,
  newFooter
  // {
  //   path: '/login',
  //   name: 'Login',
  //   meta: {
  //     title: '廉洁风险防控平台'
  //   },
  //   component: () => import('@/views/login/index1')
  // },
  // {
  //   path: '/loading',
  //   name: 'Loading',
  //   component: () => import('@/views/login/loading')
  // }
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.query.radar) {
    var h = document.createElement('script')
    h.src = 'https://zhulong-lib.oss-cn-beijing.aliyuncs.com/js/time_position_tools.js'
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(h, s)
  }
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = ''
  }
  next()
})

const originalReplace = VueRouter.prototype.replace
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}
export default router
